import IconBase from "../IconBase";

const AnghamiIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M17.6985 21.115C15.9898 22.1833 14.0152 22.7499 12 22.75C6.063 22.75 1.25 17.937 1.25 12C1.25 6.063 6.063 1.25 12 1.25C17.937 1.25 22.75 6.063 22.75 12V21.75"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16.631 19.6685C15.2339 20.5128 13.6324 20.9589 12 20.9585C7.0525 20.9585 3.0415 16.9475 3.0415 12C3.0415 7.0525 7.0525 3.0415 12 3.0415C16.9475 3.0415 20.9585 7.0525 20.9585 12V21.246"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16.6305 17.47C15.3366 18.5656 13.696 19.167 12.0005 19.167C8.042 19.167 4.8335 15.958 4.8335 12.0005C4.8335 8.04298 8.0425 4.83398 12 4.83398C15.9575 4.83398 19.1665 8.04248 19.1665 12V20.742"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16.633 14.7255C16.1584 15.5324 15.4813 16.2014 14.6687 16.6662C13.8561 17.131 12.9361 17.3755 12 17.3755C9.0315 17.3755 6.625 14.969 6.625 12.0005C6.625 9.032 9.0315 6.625 12 6.625C14.9685 6.625 17.375 9.032 17.375 12V20.238"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default AnghamiIcon;
